import { Component, OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification/notification.service';
import * as moment from 'moment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements DoCheck {
    currentTab: string = 'home';

    constructor(
        public router: Router,
        private notificationService: NotificationService
    ) {}
    notificationDot: boolean = false;
    allNotificationCount = 0;
    newNotificationCount = '';

    ngOnInit(): void {
        this.getNotificationCount();
    }

    ngDoCheck(): void {
        this.currentTab = this.router.url;
        if (this.router.url == '/notification' && this.notificationDot) {
            localStorage.setItem(
                'notification-count',
                this.allNotificationCount.toString()
            );
            this.newNotificationCount = '';
            this.notificationDot = false;
        }
    }

    checkNotificationDelay() {
        if (window.navigator.onLine) {
            let notifLastFetched = localStorage.getItem('last-notification');

            let newTime = moment().unix();
            if (notifLastFetched) {
                if (moment().isSameOrAfter(moment(+notifLastFetched * 1000))) {
                    this.getNotificationCount();
                    this.setLastNotificationTime(newTime);
                }
            } else {
                this.getNotificationCount();
                this.setLastNotificationTime(newTime);
            }
        }
    }
    getNotificationCount() {
        if (window.navigator.onLine) {
            this.notificationService.getNotificationCount().then((data) => {
                if (!localStorage.getItem('notification-count')) {
                    localStorage.setItem('notification-count', '0');
                }
                let storageNotifyCount = +(
                    localStorage.getItem('notification-count') || '0'
                );
                if (data.count != storageNotifyCount) {
                    if (data.count - storageNotifyCount > 0) {
                        this.newNotificationCount =
                            data.count - storageNotifyCount < 10
                                ? (data.count - storageNotifyCount).toString()
                                : '9+';
                    }
                    this.allNotificationCount = data.count;
                    this.notificationDot = true;
                }
            });
        }
    }

    setLastNotificationTime(currentTime: number) {
        localStorage.setItem(
            'last-notification',
            moment(currentTime * 1000)
                .add(6, 'hours')
                .unix()
                .toString()
        );
    }
}
